import { Component } from '@angular/core';
import { MAPSPartnerTokenEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Partner Tokens') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapspartnertoken-form',
    templateUrl: './mapspartnertoken.form.component.html'
})
export class MAPSPartnerTokenFormComponent extends BaseFormComponent {
    public record!: MAPSPartnerTokenEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'uploadedDocuments', sectionName: 'Uploaded Documents', isExpanded: false },
            { sectionKey: 'exportLogs', sectionName: 'Export Logs', isExpanded: false },
            { sectionKey: 'searchLogs', sectionName: 'Search Logs', isExpanded: false },
            { sectionKey: 'partnerTokenUsers', sectionName: 'Partner Token Users', isExpanded: false },
            { sectionKey: 'contactMessages', sectionName: 'Contact Messages', isExpanded: false }
        ]);
    }
}

